import React from "react";
//

import { SEOHelmet } from "../components/common/SEOHelmet";
import { TeamPreviewSection } from "../components/common/TeamPreviewSection";
import { TreatmentInfoBanner } from "../components/common/TreatmentInfoBanner";
import { LogoSvg } from "../components/svgs/LogoSvg";
import { InstagramSection } from "../components/common/InstagramSection";
//
import { PrimaryButton } from "../components/common/PrimaryButton";
import { PATH_GROUP_THERAPY } from "../utils/constants";
import groupsData from "../data/groups.json";
import { Group } from "../types/group";
import { Link } from "react-router-dom";

// removed unused 'data' definition

export default function StartPage() {
  

  return (
    <>
      <SEOHelmet page="start" />

      <main className="space-y-12 sm:space-y-24">
        {/* Hero Section */}
        <section className="mx-auto px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-12 lg:gap-x-8 xl:gap-x-12 items-center">
            <div className="lg:col-span-7 xl:col-span-6">
              <header className="mb-8">
                <LogoSvg
                  classNames="h-16 w-auto fill-current text-ergo-500 dark:text-ergo-400"
                  aria-label="Ergotherapie Rottweil Logo"
                />
              </header>
              <h1
                className="text-4xl sm:text-6xl lg:text-6xl font-bold tracking-tight leading-[1.15] 
                bg-gradient-to-br from-gray-900 via-gray-800 to-ergo-600 dark:from-white dark:via-gray-100 dark:to-ergo-400 bg-clip-text text-transparent 
                drop-shadow-sm max-auto max-w-lg md:text-left 3xl:max-w-3xl"
              >
                Einzigartige Menschen, <br className="hidden sm:block" />
                <span className="text-ergo-600 dark:text-ergo-400">individuelle Therapien.</span>
              </h1>
              <div className="mt-12 sm:mt-16">
                <p className="text-lg leading-8 text-gray-600 dark:text-gray-300">
                  Herzlich willkommen in unserer Praxis für <br />
                  <span className="font-semibold text-gray-900 dark:text-white">ERGOTHERAPIE UND ZEIT(T)RÄUME</span>
                </p>
                <p className="mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300">
                  Wir unterstützen, beraten, coachen und motivieren unsere Klienten:Innen in vielfältiger Weise.
                </p>
              </div>
            </div>
            <aside className="mt-10 lg:mt-0 lg:col-span-5 xl:col-span-6">
              <img
                src={process.env.PUBLIC_URL + "/images/tree.jpeg"}
                alt="Ergotherapie Rottweil - Praxisgebäude"
                className="w-full rounded-2xl object-cover shadow-xl dark:shadow-2xl dark:shadow-black/20 aspect-[4/3] max-h-[500px]"
              />
            </aside>
          </div>
        </section>

        {/* Mission Statement Section */}
        <section className="overflow-hidden pt-6" aria-label="Unsere Mission">
          <div className="mx-auto gap-x-12 lg:flex lg:px-8">
            <p className="text-xl sm:text-lg leading-8 text-gray-600 dark:text-gray-300 mb-6 lg:mb-0">
              Es ist uns sehr wichtig, dass die Therapie an Ihrem Alltag ansetzt, sodass gemeinsam erarbeitete
              Strategien zu Hause umgesetzt werden können. Wir setzen an Ihren aktuellen Bedürfnissen und Wünschen an
              und beziehen ihre bereits vorhandenen Ressourcen mit in die Therapie ein.
            </p>
            <p className="text-xl sm:text-lg leading-8 text-gray-600 dark:text-gray-300">
              Die ganzheitliche Betrachtungsweise unserer Klienten:Innen ist uns sehr wichtig. Deshalb werden nach
              Möglichkeit auch Angehörige bzw. enge Bezugspersonen mit in die Therapie integriert. Unsere
              Behandlungsschwerpunkte liegen in den Bereichen{" "}
              <span className="font-semibold text-gray-900 dark:text-white">Neurologie</span> und{" "}
              <span className="font-semibold text-gray-900 dark:text-white">Psychiatrie</span>.
            </p>
          </div>

          <div className="mt-16">
            <TreatmentInfoBanner />
          </div>
        </section>

        {/* Gruppentherapien CTA */}
        <section className="mx-auto px-6 lg:px-8" aria-label="Gruppentherapien Hinweis">
          <div className="relative overflow-hidden rounded-2xl border border-ergo-100/60 dark:border-gray-700/60 bg-gradient-to-br from-ergo-50 via-white to-white dark:from-gray-800 dark:via-gray-900 dark:to-gray-900 shadow-[0_8px_30px_rgb(0,0,0,0.04)] dark:shadow-[0_8px_30px_rgb(0,0,0,0.2)] p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-gray-900 dark:text-white">Gruppentherapien</h2>
              <p className="mt-2 text-base sm:text-lg text-gray-600 dark:text-gray-300 max-w-2xl">
                Neu: Unsere Gruppentherapien – kompakt vorgestellt mit Inhalten und PDF.
              </p>
              {/* Preview of first 3 group covers */}
              <Link to={PATH_GROUP_THERAPY} className="group inline-block mt-4" aria-label="Gruppentherapien Vorschau öffnen">
                <div className="flex items-center -space-x-4">
                  {((groupsData as { groups: Group[] }).groups).map((g, i) => (
                    <img
                      key={g.id}
                      src={g.coverImage || `/images/gruppen/${g.id}-cover.jpg`}
                      onError={(e) => {
                        const el = e.currentTarget as HTMLImageElement;
                        el.src = `/images/gruppen/${g.id}-cover-1.jpg`;
                      }}
                      alt={`${g.title} – Cover`}
                      className={`h-28 w-20 sm:h-32 sm:w-24 object-cover rounded-xl ring-2 ring-white dark:ring-gray-900 shadow-md transition-transform duration-300 ${i % 3 === 0 ? "rotate-[-2deg]" : i % 3 === 1 ? "rotate-0" : "rotate-[2deg]"} group-hover:-translate-y-0.5`}
                    />
                  ))}
                </div>
              </Link>
            </div>
            <div className="flex-shrink-0">
              <PrimaryButton to={PATH_GROUP_THERAPY}>Zur Übersicht</PrimaryButton>
            </div>
          </div>
        </section>

        {/* Team Preview Section */}
        <TeamPreviewSection />

        

        {/* Instagram Section */}
        <InstagramSection />

        
      </main>
    </>
  );
}
